
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0zM5 11.98C5 8.131 8.14 5 12 5s7 3.131 7 6.98c0 .545-.046.987-.148 1.43l-.001.007a7.4 7.4 0 01-.079.295c-.173.552-.486 1.011-.906 1.329a2.368 2.368 0 01-1.609.47 2.277 2.277 0 01-1.749-1.042 3.54 3.54 0 01-6.05-2.489 3.54 3.54 0 013.542-3.53 3.54 3.54 0 013.54 3.53v1.138c.004.664.45.936.832.967.38.029.886-.192 1.062-.912.087-.395.13-.796.13-1.193 0-3.06-2.496-5.549-5.564-5.549-3.069 0-5.565 2.49-5.565 5.55 0 3.059 2.496 5.548 5.565 5.548a5.552 5.552 0 003.004-.88l.016-.01.943 1.094-.02.013A6.973 6.973 0 0112 18.96c-3.86 0-7-3.131-7-6.98z","fill":"currentColor"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M14.106 11.98a2.105 2.105 0 01-4.211 0 2.105 2.105 0 014.21 0z","fill":"currentColor"}})])
          )
        }
      }
    